var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "87.629mm",
    height: "135.39mm",
    viewBox: "0 0 87.629 135.39",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.6969 -32.925)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-50.947 -76.816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m109.85 192.09c0.73637-0.0727 3.1418-0.677 4.2306-0.94825l5.9128-2.0658s3.578-1.199 8.066-5.0148c4.488-3.8159 11.081-10.899 12.555-14.606 1.4743-3.7074 3.7347-8.9686 4.3851-14.454s0.34401-17.355-3.3748-23.308-9.6342-13.221-16.269-16.126c-6.6344-2.9053-19.313-7.0881-29.203-5.4702-9.8896 1.6179-17.147 1.4835-31.129 8.995-13.982 7.5116-3.8106 21.724-3.8106 21.724s2.3221 3.0156 5.1623 5.2487c2.8402 2.2332 9.7007 2.038 9.7007 2.038s4.3396-2.059 8.5224-3.6834c4.1828-1.6244 20.887-5.6832 23.826-0.49726 2.9392 5.186 1.487 0.78261 3.525 6.7449 2.038 5.9623-6.7478 13.232-6.7478 13.232s-6.4859 5.0359-14.387 7.0141-8.6924-3.3196-9.2083 2.082c-0.51586 5.4016 0.68137 17.846 2.7627 21.944 2.0814 4.0977 4.7463 7.5018 10.558 9.3154 5.8122 1.8136 12.451-3.4398 12.451-3.4398s2.2363-8.0804 2.4713-8.7241z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.807,
    y: 214.99,
    width: 35.261,
    height: 30.145,
    rx: 11.151,
    ry: 12.971
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionmark);
export default __webpack_public_path__ + "static/media/Questionmark.58674af9785bc0154419cf37d74573d6.svg";
export { ForwardRef as ReactComponent };